import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Star from "@material-ui/icons/Star";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";
import { withTheme } from "@material-ui/core/styles";

import {
  getQualifications,
  editQualificationOnSubmit,
  initializeEditQualification,
  createQualificationOnSubmit,
  deleteQualification,
} from "features/planner/planner.actions";

import {
  ACTIONS,
  SORT_DIRECTION,
  QUALIFICATION_FORM,
} from "features/planner/planner.constants";

import {
  getSummarizedDataStatesFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import CrudBasePage from "app/components/CrudBasePage";
import { getAccessControlButton } from "utils/component.util";
import { getModifiedByValue, hasRequiredAccessLevel } from "utils/app.util";
import { getQualificationsFromState } from "features/planner/planner.selectors";
import SortableListRowIcon from "app/components/SortableList/SortableListRowIcon";
import QualificationForm from "features/planner/settings/qualifications/components/QualificationForm";
import QualificationModalTabs from "features/planner/settings/qualifications/components/QualificationModalTabs";

const SettingsQualificationsContainer = ({
  Icon,
  theme,
  dataState,
  breadcrumb,
  crudAccessLevel,
  qualifications,
  currentUserAppRoles,
  dispatchGetQualifications,
  dispatchDeleteQualification,
  dispatchEditQualificationOnSubmit,
  dispatchInitializeEditQualification,
  dispatchCreateQualificationOnSubmit,
}) => {
  useEffect(() => {
    dispatchGetQualifications();
  }, [dispatchGetQualifications]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: qualification => qualification.get("name"),
      },
      {
        xs: true,
        component: Grid,
        title: "Modified by",
        getSortProperty: item => item.get("modifiedBy"),
        getValue: getModifiedByValue,
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteQualification,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteQualification],
  );

  const renderIcon = qualification => {
    const backgroundColor = qualification.get("backColor");
    return (
      <SortableListRowIcon
        transparent
        style={{
          backgroundColor,
        }}
      >
        <Star
          style={{
            color: theme.palette.getContrastText(backgroundColor),
          }}
        />
      </SortableListRowIcon>
    );
  };

  return (
    <CrudBasePage
      Icon={Icon}
      title={breadcrumb}
      items={qualifications}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      EditEntityFormComponent={QualificationForm}
      CreateEntityFormComponent={QualificationForm}
      SortableListProps={{
        Icon: null,
        defaultSortColumn: 0,
        actions: actions,
        columns: columns,
        renderIcon: renderIcon,
        getKey: qualification => qualification.get("id"),
        defaultSortDirection: SORT_DIRECTION.ASC,
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditQualification
          : null,
      }}
      EditModalProps={{
        submitText: "Save",
        title: "Edit qualification",
        formTitleField: QUALIFICATION_FORM.NAME,
        onSubmit: dispatchEditQualificationOnSubmit,
        Tabs: QualificationModalTabs,
      }}
      CreateModalProps={{
        submitText: "Create",
        title: "Create qualification",
        Tabs: QualificationModalTabs,
        onSubmit: dispatchCreateQualificationOnSubmit,
      }}
      editEntityForm={{
        form: QUALIFICATION_FORM.ID,
      }}
      createEntityForm={{
        form: QUALIFICATION_FORM.ID,
      }}
    />
  );
};

export default compose(
  connect(
    state => ({
      qualifications: getQualificationsFromState(state),
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_QUALIFICATIONS,
        ACTIONS.DELETE_QUALIFICATION,
      ),
    }),
    {
      dispatchGetQualifications: getQualifications,
      dispatchEditQualificationOnSubmit: editQualificationOnSubmit,
      dispatchDeleteQualification: deleteQualification,
      dispatchInitializeEditQualification: initializeEditQualification,
      dispatchCreateQualificationOnSubmit: createQualificationOnSubmit,
    },
  ),
  withTheme,
)(SettingsQualificationsContainer);
